import { getSolanaConnection } from '../connection';
import { decodeGlobalConfigAccount } from '../decoders/globalConfig';
import { getGlobalConfigPda } from '../pdas/globalConfig';

export function subscribeToGlobalConfig(onUpdate, onError) {
  const connection = getSolanaConnection();
  const publicKey = getGlobalConfigPda();

  const subscriptionId = connection.onAccountChange(
    publicKey,
    (accountInfo, context) => {
      try {
        onUpdate({
          publicKey: publicKey.toBase58(),
          data: decodeGlobalConfigAccount(accountInfo.data),
          slot: context.slot,
        });
      } catch (error) {
        onError?.(error);
      }
    },
    'confirmed'
  );

  return () => connection.removeAccountChangeListener(subscriptionId);
}
